@if (label) {
  <label [for]="id" class="ctv-upload-button-label">
    {{label}}
  </label>
}
@if (!videoPreview && !file) {
  <label [for]="id" class="ctv-upload-button">
    <span class="fal fa-upload text-primary mr-3"></span>
    <span>Upload</span>
    <input type="file" class="d-none"
      [id]="id" #fileInput
      (change)="handleFileInput($event)">
    </label>
  }
  @if (videoPreview) {
    <div class="ctv-upload-preview">
      <div class="ctv-upload-preview-image" ngClass="{{fileName ? 'col-4' : 'col-12'}}">
        <video [src]="videoPreview" alt="" width="100%"></video>
        <div class="ctv-upload-preview-delete">
          <button mat-mini-fab color="warn" class="mat-elevation-z0" (click)="removeVideo()" matTooltip="Delete">
            <i class="fal fa-trash-alt" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      @if (fileName) {
        <div class="col ctv-upload-preview-name">
          <p class="mb-0">
            <small>File name:</small> <br>
            <span>{{file.name}}</span>
          </p>
        </div>
      }
    </div>
  }
